import React from "react";
const Loading = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-black backdrop-blur-lg">
      <div className="shapes"></div>
    </div>
  );
};

export default Loading;
